module.exports = __webpack_public_path__ + "img/detail-views.b4b5aa34.svg";